import { createApp } from 'vue'
import ProductsCardsSlider from './ProductsCardsSlider'

const el = '.kb-component--products-cards-slider'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM) {
        DOM.forEach((ProductsCardsSliderDOM) => {
            if (ProductsCardsSliderDOM.hasAttribute('data-v-app')) return false

            const props = {
                sliderId: ProductsCardsSliderDOM.id,
                results: ProductsCardsSliderDOM.dataset.contentjson
                    ? JSON.parse(ProductsCardsSliderDOM.dataset.contentjson)
                    : [],
                glideBehaviour: ProductsCardsSliderDOM.dataset.glideBehaviour,
                type: ProductsCardsSliderDOM.dataset.type,
                link: ProductsCardsSliderDOM.dataset.link
                    ? JSON.parse(ProductsCardsSliderDOM.dataset.link)
                    : null
            }

            const component = createApp(ProductsCardsSlider, props).use(Store)
            component.mount(ProductsCardsSliderDOM)
        })
    }
}
